var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_70_5",
    "data-name": "Component 70 \\u2013 5",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.991,
    height: 18,
    viewBox: "0 0 23.991 18",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M3.991,12.127V16a2,2,0,0,0,2,2h16a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2h-3.17l-1.83-2h-6L8.4,3h2.6l.88-1h4.24l1.83,2h4.05V16h-16V12.127ZM13.991,5a5,5,0,1,0,5,5,5,5,0,0,0-5-5m0,8a3,3,0,1,1,3-3,3,3,0,0,1-3,3",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M5.988,3.992V0h-2V3.992H0V5.987H3.992V9.979h2V5.987H9.98V3.992Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPlus);
export default __webpack_public_path__ + "static/media/camera_plus.f8898f631c1e68b13af505b5fc480921.svg";
export { ForwardRef as ReactComponent };